<template>
  <div class="info">
    <div class="btns">
      <div class="b-wrap">
        <el-button @click="navBack">返回</el-button>
        <el-button type="success" @click="checkPass">审核通过</el-button>
        <el-button type="danger" @click="checkFail">审核不通过</el-button>
      </div>
    </div>
    <div class="i-items">
      <div class="i-item-head">
        <div class="i-title">项目</div>
        <div class="i-detail">内容</div>
        <div class="i-check">审核</div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">报名编号</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.id }}</div>
          </div>
          <div class="i-check"></div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">申报单位</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent(info.companyName)"></div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.companyName_checked">不符合</el-checkbox>
            <el-input
              v-if="info.companyName_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.companyName_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">营业执照照片</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.businessLicense"
                v-for="(item, index) in info.businessLicense"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.businessLicense" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.businessLicense_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.businessLicense_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.businessLicense_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品名称</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent(info.productName)"></div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.productName_checked">不符合</el-checkbox>
            <el-input
              v-if="info.productName_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.productName_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
        <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品类型</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.productType }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.productType_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.productType_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.productType_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品原产地</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent(info.originCountry)"></div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.originCountry_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.originCountry_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.originCountry_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品包装图</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.productWrap"
                v-for="(item, index) in info.productWrap"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.productWrap" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.productWrap_checked">不符合</el-checkbox>
            <el-input
              v-if="info.productWrap_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.productWrap_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品实拍图</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.productReal"
                v-for="(item, index) in info.productReal"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.productReal" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.productReal_checked">不符合</el-checkbox>
            <el-input
              v-if="info.productReal_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.productReal_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品资质</div>
          <div class="i-detail">
            <div class="i-imgs" v-if="info.another && info.another.length > 0">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.another"
                v-for="(item, index) in info.another"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.another" :key="index" /> -->
            </div>
            <span v-else>未传图片</span>
          </div>
          <div class="i-check" v-if="info.another.length > 0">
            <el-checkbox v-model="info.another_checked">不符合</el-checkbox>
            <el-input
              v-if="info.another_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.another_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">商品类型</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-if="info.productQualification == 1">
              生鲜
            </div>
            <div class="i-d-wrap" v-if="info.productQualification == 2">
              保健品
            </div>
            <div class="i-d-wrap" v-if="info.productQualification == 3">
              其他
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.productQualification_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.productQualification_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.productQualification_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productQualification == 1">
        <div class="i-info">
          <div class="i-title">采购协议</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.freshAgreement"
                v-for="(item, index) in info.freshAgreement"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.freshAgreement" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.freshAgreement_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.freshAgreement_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.freshAgreement_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productQualification == 2">
        <div class="i-info">
          <div class="i-title">保健品批准证</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.approvalCertificate"
                v-for="(item, index) in info.approvalCertificate"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.approvalCertificate" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.approvalCertificate_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.approvalCertificate_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.approvalCertificate_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productQualification == 2">
        <div class="i-info">
          <div class="i-title">保健品卫生许可证</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.sanitaryPermit"
                v-for="(item, index) in info.sanitaryPermit"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.sanitaryPermit" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.sanitaryPermit_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.sanitaryPermit_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.sanitaryPermit_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">其他证书</div>
          <div class="i-detail">
            <div
              class="i-imgs"
              v-if="info.otherProductQualification.length > 0"
            >
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.otherProductQualification"
                v-for="(item, index) in info.otherProductQualification"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.otherProductQualification" :key="index"/> -->
            </div>
            <span v-else>未传图片</span>
          </div>
          <div class="i-check" v-if="info.otherProductQualification.length > 0">
            <el-checkbox v-model="info.otherProductQualification_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.otherProductQualification_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.otherProductQualification_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">商标</div>
          <div class="i-detail">
            <div class="i-d-wrap">
              {{ info.brandRegisterCard == 1 ? "自持" : "第三方转让" }}
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.brandRegisterCard_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.brandRegisterCard_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.brandRegisterCard_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">商标注册证正面</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.brandRegisterCardFront"
                v-for="(item, index) in info.brandRegisterCardFront"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.brandRegisterCardFront" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.brandRegisterCardFront_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.brandRegisterCardFront_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.brandRegisterCardFront_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">商标注册证反面</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.brandRegisterCardBack"
                v-for="(item, index) in info.brandRegisterCardBack"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.brandRegisterCardBack" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.brandRegisterCardBack_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.brandRegisterCardBack_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.brandRegisterCardBack_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.brandRegisterCard == 2">
        <div class="i-info">
          <div class="i-title">第三方营业执照复印件</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.thirdBusinessLicense"
                v-for="(item, index) in info.thirdBusinessLicense"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.thirdBusinessLicense" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.thirdBusinessLicense_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.thirdBusinessLicense_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.thirdBusinessLicense_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.brandRegisterCard == 2">
        <div class="i-info">
          <div class="i-title">转让说明</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.brandRegisterCardDesc }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.brandRegisterCardDesc_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.brandRegisterCardDesc_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.brandRegisterCardDesc_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">生产方式</div>
          <div class="i-detail">
            <div class="i-d-wrap">
              {{ info.productMode == "1" ? "自己生产" : "委托生产" }}
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.productMode_checked">不符合</el-checkbox>
            <el-input
              v-if="info.productMode_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.productMode_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productMode == 1">
        <div class="i-info">
          <div class="i-title">生产许可证</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.productPermit"
                v-for="(item, index) in info.productPermit"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.productPermit" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.productPermit_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.productPermit_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.productPermit_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productMode == 2">
        <div class="i-info">
          <div class="i-title">委托方生产许可证</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.delegateProductPermit"
                v-for="(item, index) in info.delegateProductPermit"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.delegateProductPermit" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.delegateProductPermit_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.delegateProductPermit_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.delegateProductPermit_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productMode == 2">
        <div class="i-info">
          <div class="i-title">委托方营业执照</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.delegateBusinessLicense"
                v-for="(item, index) in info.delegateBusinessLicense"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.delegateBusinessLicense" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.delegateBusinessLicense_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.delegateBusinessLicense_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.delegateBusinessLicense_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productMode == 2">
        <div class="i-info">
          <div class="i-title">委托方加工协议</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.delegateProcessingDeal"
                v-for="(item, index) in info.delegateProcessingDeal"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.delegateProcessingDeal" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.delegateProcessingDeal_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.delegateProcessingDeal_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.delegateProcessingDeal_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">质检合格报告</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.qualityInspectionReport"
                v-for="(item, index) in info.qualityInspectionReport"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.qualityInspectionReport" :key="index"/> -->
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.qualityInspectionReport_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.qualityInspectionReport_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.qualityInspectionReport_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品上市时间</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.marketTime }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.marketTime_checked">不符合</el-checkbox>
            <el-input
              v-if="info.marketTime_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.marketTime_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">年产量</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.yearlyOutput }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.yearlyOutput_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.yearlyOutput_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.yearlyOutput_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">年销售额</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.yearlySales }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.yearlySales_checked">不符合</el-checkbox>
            <el-input
              v-if="info.yearlySales_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.yearlySales_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">现有销售渠道</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.existingSalesChannel }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.existingSalesChannel_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.existingSalesChannel_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.existingSalesChannel_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">网络销售渠道</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.networkSalesChannel }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.networkSalesChannel_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.networkSalesChannel_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.networkSalesChannel_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">网络销售占比</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.networkSalesRatio }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.networkSalesRatio_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.networkSalesRatio_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.networkSalesRatio_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品销售旺季</div>
          <div class="i-detail">
            <div
              class="i-d-wrap"
              v-for="(item, index) in info.salesSeason"
              :key="index"
            >
              {{ item }}月<span v-if="index < info.salesSeason.length - 1"
                >，</span
              >
            </div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.salesSeason_checked">不符合</el-checkbox>
            <el-input
              v-if="info.salesSeason_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.salesSeason_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品介绍</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent( info.productSellingPoint )" ></div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.productSellingPoint_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.productSellingPoint_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.productSellingPoint_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">姓名</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent( info.contactUser)"></div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.contactUser_checked">不符合</el-checkbox>
            <el-input
              v-if="info.contactUser_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.contactUser_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">手机</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.contactPhone }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.contactPhone_checked"
              >不符合</el-checkbox
            >
            <el-input
              v-if="info.contactPhone_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.contactPhone_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">微信</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.wxNo }}</div>
          </div>
          <div class="i-check">
            <el-checkbox v-model="info.wxNo_checked">不符合</el-checkbox>
            <el-input
              v-if="info.wxNo_checked"
              placeholder="请输入不符合原因（非必填）"
              v-model="info.wxNo_remark"
            >
            </el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { query, verify } from "@/api/api";
import { Image, Input } from "element-ui";
import { showcontent } from "@/utils/method.js";


export default {
  data() {
    return {
      info: {
        another: [],
        otherProductQualification: [],
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      this.queryInfo();
    }
  },
   activated() {
         if (this.$route.query.id) {
      this.queryInfo();
    }
  },
  methods: {
    showcontent,
    queryInfo() {
            this.$ajaxPost("/company/query", { id: this.$route.query.id }).then((res ) => {

      // this.$api.post(query, { id: this.$route.query.id }, (res) => {
        // const imgReg = /^\[(.*)\]$/i;
        const imgReg = /\.(jpg|jpeg|png|JPG|PNG)$/;
        if (res.data.code == 0) {
          const resData = res.data.data;
          const keys = Object.keys(resData);
          // keys.forEach(key => {
          //   if(imgReg.test(resData[key]) && key != 'listVerifyRecord') {
          //     resData[key] = JSON.parse(resData[key])
          //   }
          for (const key of keys) {
            if (resData[key]) {
              let element = resData[key];
              if (imgReg.test(element)) {
                if (element.includes(",")) {
                  resData[key] = resData[key].split(",");
                } else {
                  resData[key] = [resData[key]];
                }
              }else if(key == 'salesSeason'){
                  resData[key] = resData[key].split(",");
              }
            }
          }
          keys.forEach((key) => {
            resData[key + "_checked"] = false;
            resData[key + "_remark"] = "";
          });
          this.info = resData;
        } else {
          this.$message(res.data.message);
        }
      });
    },
    checkPass() {
      const self = this;

      const keys = Object.keys(this.info);
      let checked = [];
      keys.forEach((item) => {
        if (item.indexOf("_checked") >= 0 && this.info[item] === true) {
          checked.push(true);
        }
      });

      if (checked.length > 0) {
        this.$message({
          message: "存在不符合项目",
          type: "warning",
          duration: 900,
        });
        return;
      }

      const id = this.$route.query.id;
      const postData = {
        id,
        verifyStatus: "1",
        remarks: "",
        notThroughList: "[]",
      };
      this.$ajaxPost("/company/verify", postData).then((res ) => {
      // this.$api.post(verify, postData, (res) => {
        if (res.data.code == 0) {
          this.$message({
            message: this.info.companyName + "审核通过",
            type: "success",
            duration: 900,
          });
          setTimeout(() => {
            self.$router.go(-1);
          }, 1000);
        } else {
          this.$message(res.data.message);
        }
      }).catch((error) => {
          this.$message({
            type: "danger",
            message:error,
          });
        });
    },
    checkFail() {
      const self = this;
      const id = this.$route.query.id;
      const info = this.info;
      const keys = Object.keys(info);
      let failKeys = [];
      let failRemarks = [];
      keys.forEach((key) => {
        if (info[key + "_checked"]) {
          failKeys.push(key);
          failRemarks.push(info[key + "_remark"]);
        }
      });

      if (failKeys.length <= 0) {
        this.$message({
          message: "请选择不符合的项目",
          type: "error",
        });
        return;
      }

      const postData = {
        id,
        verifyStatus: "2",
        remarks: failRemarks,
        notThroughList: failKeys,
      };
      this.$ajaxPost("/company/verify", postData).then((res) => {

      // this.$api.post(verify, postData, (res) => {
        if (res.data.code == 0) {
          this.$message({
            message: this.info.companyName + "已审核不通过",
            type: "success",
            duration: 900,
          });
          setTimeout(() => {
            self.$router.go(-1);
          }, 1000);
        } else {
          this.$message(res.data.message);
        }
      });
    },
    navBack() {
      this.$router.go(-1);
    },
  },
  components: {
    "el-img": Image,
    "el-input": Input,
  },
};
</script>

<style lang="less" scope>
.info {
  padding: 10px;
  background: #fff;
  margin-top: -10px;
    .el-image{
    width: 100px !important;
    height: 100px !important;
    margin-right: 10px !important;
  }
  .is-checked {
    .el-checkbox__label {
      color: #dd6161 !important;
    }

    .el-checkbox__inner {
      background-color: #dd6161 !important;
      border-color: #dd6161 !important;
    }
  }

  .header .el-top {
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;

    .title {
      font-size: 16px;
      font-weight: 400;
      margin: 0;
    }
  }

  .btns {
    width: 100%;
    margin-top: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8e8e8;
  }

  .i-items {
    width: 96%;
    margin-top: 20px;
    border: 1px solid #d8d8d8;
    border-radius: 10px;

    .i-item {
      width: 100%;
      display: flex;
      align-items: center;
    }

    & > .i-item:last-child .i-info {
      border-bottom: none;
    }

    .i-item-head {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      color: #3f3f3f;
      border-bottom: 1px solid #e8e8e8;
      font-size: 14px;
      background-color: #f2f2f2;

      & > div {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    .i-info {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #727272;
      border-bottom: 1px solid #d8d8d8;

      & > div {
        min-height: 40px;
        display: flex;
        align-items: center;
      }
    }

    .i-title {
      width: 20%;
      padding-left: 8px;
      box-sizing: border-box;
    }

    .i-detail {
      width: 56%;
      padding-left: 8px;
      box-sizing: border-box;
      border-left: 1px solid #e9e9e9;
      border-right: 1px solid #e9e9e9;
    }

    .i-check {
      width: 24%;
      padding-left: 8px;
      padding-right: 8px;
      box-sizing: border-box;

      .el-input__inner {
        height: 30px;
        margin-left: 6px;
        padding: 0 5px;
        line-height: 30px;
        font-size: 12px;
      }
    }

    .i-imgs {
      padding: 10px 0;
      padding-top: 20px;

      img {
        width: 90px;
        height: 90px;
        margin-right: 10px;
        margin-bottom: 10px;
        object-fit: cover;
      }
    }
  }
}
</style>
